import {
  CollectionViewer,
  DataSource,
  ListRange,
} from '@angular/cdk/collections';
import { Observable, BehaviorSubject, Subscription } from 'rxjs';

export class YearDataSource extends DataSource<number> {
  private dataStream: BehaviorSubject<number[]>;
  private subscription: Subscription;
  private scrollLimit = 1;

  constructor(baseYear: number, pageSize: number) {
    super();
    const startValue = this.generateYearRange(
      baseYear - this.scrollLimit,
      pageSize + 2 * this.scrollLimit + 2
    );
    this.dataStream = new BehaviorSubject(startValue);
    this.subscription = new Subscription();
  }

  private generateYearRange(start: number, length: number): number[] {
    return Array(length)
      .fill(start)
      .map((base, index) => base + index);
  }

  private getScrollOverflow(rendered: ListRange): number {
    const bottomOverflow = this.scrollLimit - rendered.start;
    if (bottomOverflow > 0) {
      return -bottomOverflow;
    }
    const length = this.dataStream.value.length;
    const topOverflow = rendered.end - length + this.scrollLimit;
    if (topOverflow > 0) {
      return topOverflow;
    }
    return 0;
  }

  /**
   * tweak year range and rendered range
   * to add ability of double way infinite scrolling
   **/
  private onViewChange(rendered: ListRange) {
    const overflow = this.getScrollOverflow(rendered);
    if (!overflow) {
      return;
    }
    const length = this.dataStream.value.length;
    const nextItems =
      overflow < 0
        ? this.generateYearRange(this.dataStream.value[0] + overflow, length)
        : this.generateYearRange(this.dataStream.value[0], length + overflow);
    this.dataStream.next(nextItems);
    if (overflow < 0) {
      rendered.start -= overflow;
      rendered.end -= overflow;
    }
  }

  connect(collectionViewer: CollectionViewer): Observable<number[]> {
    this.subscription.add(
      collectionViewer.viewChange.subscribe(this.onViewChange.bind(this))
    );
    return this.dataStream.asObservable();
  }

  disconnect() {
    this.subscription.unsubscribe();
  }
}
